import { ReactNode } from "react";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import {
  createMuiTheme,
  createTheme,
  ThemeProvider,
} from "@mui/material/styles";
import XAppBar from "../components/x-app-bar";
import XModal, { IModal } from "../components/x-modal";

const theme = createTheme({
  palette: {
    background: {
      default: "#f8fafc", // Cor de fundo padrão
    },
  },
});

export default function LayoutApp({
  children,
  hiddenAppBar,
  controllModal,
}: {
  hiddenAppBar?: boolean;
  children: ReactNode;
  controllModal?: IModal;
}) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {!hiddenAppBar && <XAppBar />}
      <Container
        sx={{
          py: 2,
        }}
        component="main"
        maxWidth="lg"
      >
        <XModal {...controllModal} />
        <body>{children}</body>
      </Container>
    </ThemeProvider>
  );
}
